var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"pushable",style:(_vm.stylePush),on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('span',{staticClass:"front",style:(_vm.styleFront)},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }